module.exports = __webpack_public_path__ + "static/media/box_border_1.231a083a.png";